import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StudyEditorContext } from '../../../../study-editor.context';
import { Subject } from 'rxjs';
import { AlertService } from '../../../../../shared/alert/alert.service';
import { parseFile } from '../../../../../shared/util/file-utils';
import { CrossService } from '../../../../../shared/study/service/cross.service';
import { ImportCrossesSettingsModalComponent } from '../import-crosses-settings-modal/import-crosses-settings-modal.component';
import { ImportCrossesContext } from '../import-crosses-context';
import { ChooseListUserModalComponent } from '../choose-list-user-modal/choose-list-user-modal.component';
import { ImportCrossesResponseModel } from '../../../../../shared/study/model/import-crosses.response.model';

interface ImportFormat {
    name: string;
    extension: string;
    isVisible: boolean;
}


@Component({
    selector: 'jhi-import-crosses-modal',
    templateUrl: './import-crosses-modal.component.html',
    styleUrl: './import-crosses-modal.component.scss'
})
export class ImportCrossesModalComponent {

    @ViewChild('fileUpload') fileUpload!: ElementRef;

    datasetId: number;

    file: File | null = null;
    importedData: any[] | null = null;
    isTransposed = false;
    rawData = new Array<any>();

    importFormats: ImportFormat[] = [];
    selectedFormat: ImportFormat | null = null;

    private destroy$ = new Subject<void>();
    isSaving: boolean;

    constructor(
        public modalService: NgbModal,
        public activeModal: NgbActiveModal,
        private studyEditorContext: StudyEditorContext,
        private context: ImportCrossesContext,
        private alertService: AlertService,
        private crossService: CrossService
    ) {
    }

    ngOnInit(): void {
        this.selectedFormat = this.importFormats[1];
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    backToDatasetOptionModal(): void {
        this.activeModal.dismiss('back');
    }

    clearSelectedFile(): void {
        this.file = null;
        this.importedData = null;
        this.rawData = null;
    }

    continue($event) {
        // get Description sheet
        parseFile(this.file, 'Description').subscribe((value) => {
            this.proceedWithObservation(value);
        }, (error) => this.alertService.error('error.custom', { param: error }));
    }

    proceedWithObservation(descriptionRawData: any) {
        if (this.rawData && this.rawData.length >= 2) {
            // normalize headers
            this.rawData[0] = this.rawData[0].map((header) => header.toUpperCase());
            const headers = this.rawData[0];
            this.importedData = this.rawData.slice(1).map((fileRow, rowIndex) => {
                return fileRow.reduce((map, col, colIndex) => {
                    map[headers[colIndex]] = col;
                    return map;
                }, {});
            });

            this.crossService.importFile(this.studyEditorContext.studyId, {
                observationRawData: this.importedData,
                observationHeaders: headers,
                descriptionRawData: descriptionRawData
            }).subscribe((res: ImportCrossesResponseModel) => {
                this.context.listMetadata = res;

                if (res.choosingListOwnerNeeded) {
                    const chooseUserModal = this.modalService.open(ChooseListUserModalComponent as Component, { size: 'lg', backdrop: 'static' });

                    chooseUserModal.result.then((selectedUser) => {
                        if (selectedUser) {
                            this.context.listMetadata.listOwner = selectedUser;
                            this.activeModal.close();
                            this.openCrossesSettingsModal();
                        }
                    }, () => this.activeModal.dismiss());
                } else {
                    this.openCrossesSettingsModal();
                }
            });
        } else {
            this.alertService.error('study-editor.import-crosses.import-file.error.reading-file');
        }
    }

    openCrossesSettingsModal() : void {
        const crossingSettingsModal = this.modalService.open(ImportCrossesSettingsModalComponent as Component, { size: 'xl', backdrop: 'static' });
        crossingSettingsModal.result.then(() => {
            this.activeModal.close();
        }, () => this.activeModal.dismiss());
    }

    close(): void {
        this.activeModal.close();
    }

    handleFileChange(event: any): void {
        const target = event.target;
        this.file = target.files[0];
        this.importedData = null;
        this.rawData = null;
        parseFile(this.file, 'Observation').subscribe((value) => {
            this.rawData = value;
        }, (error) => this.alertService.error('error.custom', { param: error }));
    }

    cancel(): void {
        this.activeModal.dismiss('back');
    }

}
